import style from '../CSS/RoundVideoResult.module.css'
import Button from "./Button";

const MargeCard = () => {
    return (
        <>
            <div className={style.merge__card}>
                <div className={style.merge__card__body}>
                    <h6>Top</h6>
                    <div className={style.merge__card__input}>
                        <button>-</button>
                        <input type="text" value="85%" />
                        <button style={{ marginRight: "12px" }}>+</button>
                    </div>
                    <h6>mark user qualify for the next round</h6>
                </div>
                <div style={{ margin: '40px 0px 0px', textAlign: 'center' }}>
                    <Button text={'merge all the video'} />
                </div>
            </div>
        </>
    );
};

export default MargeCard;